// extracted by mini-css-extract-plugin
module.exports = {"root":"TextInputCss_root__1T76O","text_input":"TextInputCss_text_input__1B-N5","error_input":"TextInputCss_error_input__2Sszb","error_msg":"TextInputCss_error_msg__3ViRE"};